import { useSite } from "@/lib/useSite";

export default function DealersSection() {
  const { data } = useSite();
  const dealers = data?.dealers || [];
  const s = data?.settings || {};

  if (!dealers.length) return null;

  return (
    <div data-testid="dealers-section">
      <h2 className="mb-10 font-display text-3xl font-bold tracking-tight text-ink sm:text-4xl">
        {s.dealers_title || "Authorized Distributor for"}
      </h2>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 sm:gap-6 lg:grid-cols-4 xl:grid-cols-6">
        {dealers.map((d) => (
          <div
            key={d.id}
            className="flex h-36 w-full items-center justify-center rounded-2xl border border-ink/10 bg-white p-2 grayscale transition-all duration-500 hover:grayscale-0 sm:h-40 sm:p-3"
          >
            {d.logo && (
              <img
                src={d.logo}
                alt={d.name || "Dealer logo"}
                className="h-5/6 w-5/6 object-contain"
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
